document.addEventListener('DOMContentLoaded', function () {
  const starsElement = [...document.querySelectorAll('.rich-text__caption')]
    .find(el => el.textContent.trim() === '⭐⭐⭐⭐⭐');

  if (!starsElement) return;

  if (!document.querySelector('#rotating-testimonial-style')) {
    const style = document.createElement('style');
    style.id = 'rotating-testimonial-style';

    style.textContent = `
      .rotating-testimonial-wrapper {
        transition: opacity 0.6s ease;
        opacity: 1;
      }

      .rotating-testimonial-text {
        margin: 16px auto 0;
        max-width: 520px;
        font-family: var(--font-heading-family);
        font-size: 22px;
        line-height: 1.4;
        font-weight: 400;
        color: #2f2a24;
        text-align: center;
      }

      .rotating-testimonial-author {
        margin-top: 10px;
        font-family: var(--font-body-family);
        font-size: 13px;
        line-height: 1.4;
        font-weight: 400;
        color: #7a6a5d;
        text-align: center;
      }

      @media screen and (max-width: 749px) {
        .rotating-testimonial-text {
          font-size: 18px;
          max-width: 90%;
        }

        .rotating-testimonial-author {
          font-size: 12px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  if (starsElement.nextElementSibling?.classList.contains('rotating-testimonial-wrapper')) return;

  const testimonials = [
    {
      text: '“Beautiful quality and the engraving is perfect. Bought as a birthday gift and it was loved!”',
      author: '– Sophie, London'
    },
    {
      text: '“Such a thoughtful little gift. The personal detail made it feel really special.”',
      author: '– Emma, Manchester'
    },
    {
      text: '“Lovely craftsmanship, fast delivery, and exactly what I wanted. I would definitely order again.”',
      author: '– Chloe, Bristol'
    }
  ];

  let currentIndex = 0;

  const wrapper = document.createElement('div');
  wrapper.className = 'rotating-testimonial-wrapper';

  const textEl = document.createElement('p');
  textEl.className = 'rotating-testimonial-text';
  textEl.textContent = testimonials[currentIndex].text;

  const authorEl = document.createElement('p');
  authorEl.className = 'rotating-testimonial-author';
  authorEl.textContent = testimonials[currentIndex].author;

  wrapper.appendChild(textEl);
  wrapper.appendChild(authorEl);

  starsElement.insertAdjacentElement('afterend', wrapper);

  setInterval(function () {
    wrapper.style.opacity = '0';

    setTimeout(function () {
      currentIndex = (currentIndex + 1) % testimonials.length;

      textEl.textContent = testimonials[currentIndex].text;
      authorEl.textContent = testimonials[currentIndex].author;

      wrapper.style.opacity = '1';
    }, 600);
  }, 5000);
});